import { faker } from '@faker-js/faker'

import { getGroupedServiceOffer } from './GroupedServiceOfferView'
import { getPrice } from './Price'

import { AdminServiceOfferListItem, Status, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getAdminServiceOfferListItem = asBuilder((): AdminServiceOfferListItem => {
  return {
    groupedServiceOffers: faker.helpers.multiple(getGroupedServiceOffer),
    id: faker.number.int(),
    thumbnail: { url: faker.image.url() },
    status: faker.helpers.enumValue(Status),
    targetLanguage: faker.helpers.enumValue(TargetLanguage),
    title: faker.string.uuid(),
    hospital: {
      id: faker.number.int(),
      name: faker.string.uuid(),
      temporaryUnavailable: faker.datatype.boolean(),
    },
    paymentEnabled: faker.datatype.boolean(),
    surgicalRewardExist: faker.datatype.boolean(),
    period: {
      startsAt: new Date().toISOString(),
      endsAt: new Date().toISOString(),
    },
    treatmentCategories: faker.helpers.multiple(() => ({
      treatmentCategoryId: faker.number.int(),
      name: faker.string.uuid(),
    })),
    onGuaranteedAd: faker.datatype.boolean(),
    price: {
      ...getPrice(),
      specialOffer: faker.datatype.boolean(),
    },
    includeVat: faker.datatype.boolean(),
    rating: {
      totalRating: faker.number.float({ min: 0, max: 10, multipleOf: 0.1 }),
      ratingCount: faker.number.int(),
    },
    consultationCount: faker.number.int(),
    hasDraft: faker.datatype.boolean(),
    createdAtUtc: '2023-08-09T14:18:55.559Z',
    updatedLastAtUtc: '2023-08-09T14:18:55.559Z',
  }
})
